import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import cookies from '@/utils/cookie.js';
import axios from "@/utils/index";
import moment from 'moment';
import VueLazyload from "vue-lazyload";
import 'babel-polyfill';
import promise from 'es6-promise';

Vue.config.productionTip = false
Vue.prototype.$cookies = cookies;
Vue.prototype.$moment = moment;
//require('video.js/dist/video-js.css');

Vue.use(VueLazyload);

import {
  Button, Message, Carousel, CarouselItem, Input, Popover, Cascader, Form, Radio, Tabs, TabPane, FormItem, Tooltip, Select, Option,
  DatePicker, Card, Table, TableColumn, Breadcrumb, BreadcrumbItem, CheckboxGroup, Checkbox, Pagination,Dialog,MessageBox,RadioGroup,
	RadioButton
} from 'element-ui';
import enLang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// 设置语言
locale.use(enLang)
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.use(Button);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Input);
Vue.use(Popover);
Vue.use(Cascader);
Vue.use(Form);
Vue.use(Radio);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(FormItem);
Vue.use(Tooltip);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Card);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(RadioButton);

import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/index.js';
//import 'swiper/swiper-bundle.css';
//import VueAMap from 'vue-amap'


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')